import { render, staticRenderFns } from "./AamsTravelBaseStandard.vue?vue&type=template&id=9ae9bc66&scoped=true&"
import script from "./AamsTravelBaseStandard.vue?vue&type=script&lang=js&"
export * from "./AamsTravelBaseStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae9bc66",
  null
  
)

export default component.exports